'use strict';

import request from 'superagent';

class Event {
    constructor() {
        this.searchUrl = '/report/search';
    }


    search(store) {

        // validate
        var inputNumber = document.getElementById('hakkouNo').value;
        if (inputNumber) {
            request
                .post(this.searchUrl)
                .type('form')
                .send({number: inputNumber})
                .set('accept', 'json')
                .end((err, res) => {
                    if (err) {
                        console.log(err);

                    } else {

                        store.setData(res.body.data).fillItemData().fillStatusData();

                        if (res.body.data == null) {
                            document.getElementById('hakkouNo').classList.add('invalid');



                            //var instance = basicLightbox.create(`
                            //    <h4 class="white-text text-center">存在しない発行No.です。</h1>
                            //    `);
                            //instance.show();
                        }


                    }
                })
        }


    }

}

export default Event


